




























































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator';
import { BusyObject } from '@/models/Busy';
import { Brand, BrandIndexItem, BrandQueryResultItem, BrandBookmarkContainer, BrandBookmarksService, BrandsService } from '@/api/braendz';

import VueSlickCarousel from 'vue-slick-carousel';
import Carousel3dSlider from '@/components/Carousels/Carousel3dSlider.vue';
import BrandListItem from '@/components/Brands/BrandListItem.vue';
import VerticalBrandTile from '@/components/Brands/VerticalBrandTile.vue';
import BrandDetailsButton from '@/components/Brands/BrandDetailsButton.vue';
import MonitorBrandButton from '@/components/Monitoring/MonitorBrandButton.vue';
import ConfirmationPopup from '@/components/Popups/ConfirmationPopup.vue';

@Component({
    components: {
        BrandListItem,
        VerticalBrandTile,
        VueSlickCarousel,
        Carousel3dSlider,
        BrandDetailsButton,
        MonitorBrandButton,
        ConfirmationPopup
    }
})
export default class BrandBookmarkContainerViewer extends Vue {
    // Fields
    public brands: BusyObject<Brand>[] = [];
    
    // Properties
    @Prop({ required: true })
    public container!: BrandBookmarkContainer;

    @Prop({ required: false, default: 'carousel', type: String })
    public view!: 'carousel' | 'list' | 'slider' | 'grid';

    // Getter & Setter
    public get brandItemsToShow(): number {
        return Math.ceil(window.innerWidth / 550);
    }
    
    // Watchers
    @Watch('container.brandBookmarks')
    public onBrandBookmarksChange() {
        this.reloadBrands();
    }

    // Lifecycle Methods:
    public mounted() {
        this.reloadBrands();
    }

    // Methods:
    public getIdOrIndex(item: Brand | undefined | null, index: number): string {
        return item?.id ? `Id_${item?.id}` : `Index_${index}`;
    }

    public async reloadBrands() {
        this.brands = this.container.brandBookmarks?.map(b => {
            const busyBrand = new BusyObject<Brand>();
            busyBrand.load(async () => {
                return await BrandsService.getBrand(b.id);
            });
            return busyBrand;
        }) || [];
    }

    public async removeFromBookmarks(brand: BrandQueryResultItem | BrandIndexItem | Brand | string | null | undefined) {
        if (!brand) {
            return;
        }

        // Extract brand ID based on type
        let brandId: string;
        if (typeof brand === 'string') {
            brandId = brand;
        } else {
            const extractedId = this.$braendz.getBrandId(brand);
            if (!extractedId) {
                return; // Early return if we can't extract a valid brand ID
            }
            brandId = extractedId;
        }

        await new BusyObject<void>().delete(async () => {
            if(this.container.id && brandId) {
                await BrandBookmarksService.deleteBrandBookmark(this.container.id, brandId);

                if(this.container.brandBookmarks) {
                    const index = this.container.brandBookmarks.findIndex(b => b.id === brandId);
                    if(index >= 0) {
                        this.container.brandBookmarks.splice(index, 1);
                    }
                }
            }
        });
    }
}
